import React from "react";
import { Link } from "react-router-dom";

const SimulatorForm = ({
  simulatorQuery,
  search,
  DownOutlined,
  catagories,
  menu,
  Dropdown,
}) => {
  return (
    <div>
      {simulatorQuery?.aatmsv4_simforms?.map((data, index) => {
        if (data?.simformname.toLowerCase().includes(search.toLowerCase())) {
          return (
            <div className="table-row-container" key={index}>
              <div className="table-row-top">
                <div className="items">
                  <div className="title">SimForm Name</div>
                  <div className="value">{data?.simformname}</div>
                </div>
                <div className="items">
                  <div className="title">Catagory</div>
                  <div className="value">{catagories}</div>
                </div>
                <div className="items">
                  <div className="title">Blank Form</div>

                  <div className="value">
                    <a href={data?.blankform} target="_blank">
                      BlankForm View
                    </a>
                  </div>
                </div>
                <div className="items">
                  <div className="title">Presentation</div>
                  <div className="value">
                    <a href={data?.presentation} target="_blank">
                      Presentation View
                    </a>
                  </div>
                </div>
                <div className="items">
                  <div className="title">Study Material</div>
                  <div className="value">
                    <a href={data?.studymat} target="_blank">
                      Study Material View
                    </a>
                  </div>
                </div>
                <Dropdown overlay={menu(data)}>
                  <a
                    className="ant-dropdown-link"
                    onClick={(e) => e.preventDefault()}
                  >
                    <i className="fa fa-ellipsis-h" />
                    <DownOutlined />
                  </a>
                </Dropdown>
              </div>
            </div>
          );
        }
      })}
    </div>
  );
};

export default SimulatorForm;
